
import Loading from 'vux/src/components/loading/index.vue'

import { mapState } from 'vuex'
import FootBar from '@/components/FootBar.vue'
export default {
name: 'app',
data() {
return {"isNotLoginPage":true}
},
components: {
Loading,
FootBar
},
computed: {
...mapState({
isLoading: state => state.app.isLoading
})
},
mounted() {
this.$bus.$on('isNotLoginPage', (data) => {
this.isNotLoginPage=data
})
},

}



// WEBPACK FOOTER //
// ./src/App.vue